import { useState } from "react";
import { CalendarEvent, EventBadge } from "./CalendarDayCard";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";

export const CourseEvents = ({ courseName, events }: { courseName: string; events: CalendarEvent[] }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div className="mt-4">
      <div className="flex cursor-pointer items-center justify-between" onClick={() => setIsExpanded(!isExpanded)}>
        <div className="text-xs font-semibold">{courseName}</div>
        <button className="text-slate-500 hover:text-slate-700">
          {isExpanded ? <MdKeyboardArrowUp size={18} /> : <MdKeyboardArrowDown size={18} />}
        </button>
      </div>
      {isExpanded && (
        <div className="mt-2 flex flex-col gap-1">
          {events.map((event) => (
            <EventBadge event={event} key={event.eventName} />
          ))}
        </div>
      )}
    </div>
  );
};
